var _rect, _circle, _circle2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBraking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 20,
    width: 30,
    height: 40,
    fill: "red"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 65,
    r: 5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 65,
    r: 5,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 80,
    x2: 10,
    y2: 95,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 80,
    x2: 90,
    y2: 95,
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraking);
export default __webpack_public_path__ + "static/media/braking.d7be4dcd367d45b9235d2cf8afa8ba22.svg";
export { ForwardRef as ReactComponent };